import {startOfDay, endOfDay} from 'date-fns'
import {ApiQuery, FilterValues} from './types'

export function fromFilters(filterValues: FilterValues): ApiQuery {
  const {search, completedAfter, completedBefore} = filterValues

  return normalizeQuery({
    search: search.length > 0 ? search : undefined,
    completedAfter: completedAfter != null ? startOfDay(completedAfter).toISOString() : undefined,
    completedBefore: completedBefore != null ? endOfDay(completedBefore).toISOString() : undefined,
  })
}

function normalizeQuery<T extends object>(value: T): T {
  return Object.fromEntries(Object.entries(value).filter(([key, value]) => value != null)) as T
}
